import { VisibilityState } from '@tanstack/react-table'

import { create } from 'zustand'
import { combine } from 'zustand/middleware'

export interface NestedToggleType {
  // table name: { column name: boolean }
  [key: string]: VisibilityState
}

interface CodeStates {
  table: 'logs' | 'spans' | 'metrics'
  columnVisibility: NestedToggleType
  whereClause: string
  diffIndex: number
  eventViewIndex: number
  description: string
  code: string
  consoleLog: string
  errorLog: string
}

const combineDefaults: CodeStates = {
  table: 'logs',
  columnVisibility: {},
  whereClause: '',
  diffIndex: 0,
  eventViewIndex: 0,
  description: '',
  code: '',
  consoleLog: '',
  errorLog: '',
}

export const useCodeNodeStore = create(
  combine(combineDefaults, (set) => ({
    setWhereClause: (by: string) => {
      set(() => {
        return { whereClause: by }
      })
    },
    setTable: (selectedTable: 'logs' | 'spans' | 'metrics') => {
      set(() => {
        return { table: selectedTable }
      })
    },
    setColumnVisibility: (checkboxEvent: any) => {
      set((state) => {
        const table = state.table
        const existing: VisibilityState = state.columnVisibility[table] || {}
        const perTable: NestedToggleType = {}
        perTable[table] = { ...existing, ...checkboxEvent() }

        return { columnVisibility: perTable }
      })
    },
    setDiffIndex: (index: number) => {
      set(() => {
        return { diffIndex: index }
      })
    },
    setEventViewIndex: (index: number) => {
      set(() => {
        return { eventViewIndex: index }
      })
    },
    setDescription: (description: string) => {
      set(() => {
        return { description: description }
      })
    },
    setCode: (code: string) => {
      set(() => {
        return { code: code }
      })
    },
    setConsoleLog: (consoleLog: string) => {
      set(() => {
        return { consoleLog: consoleLog }
      })
    },
    setErrorLog: (errorLog: string) => {
      set(() => {
        return { errorLog: errorLog }
      })
    },
  }))
)
